// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_ProfileMenuMiddle__Z337a {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px 0;
  width: 100%;
}

.styles_ProfileMenuMiddle__Z337a p {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #898989;
}

.styles_checkMarkStyle__dEf37 {
  width: 20px;
  height: 20px;
}

.styles_checkMarkStyle__dEf37 > input {
  display: none;
}

.styles_labelStyle__q2Cbl {
  padding: 0 !important;
}

.styles_checkMarkStyle__dEf37:after {
  left: 7px !important;
  top: 4px !important;
  width: 4px !important;
  height: 8px !important;
  border: solid white !important;
  border-width: 0 3px 3px 0 !important;
  transform: rotate(45deg) !important;
}

.styles_ProfileMenuMiddle__Z337a .styles_color__bShzK {
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

.styles_unActive__LAyLZ {
  box-shadow: 0px 0px 0px 1px gray;
  border-radius: 50%;
  position: relative;
}

.styles_activeColor__nD5C8 {
  box-shadow: 0px 0px 0px 1px #d8000d;
  border-radius: 50%;
  position: relative;
}

.styles_ProfileMenuBottom__I-3a9 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0;
  width: 100%;
  height: auto;
}

.styles_ProfileMenuBottom__I-3a9 > div,
.styles_ProfileMenuBottom__I-3a9 a {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
  border-radius: 4px;
  padding: 6px 5px;
  width: 100%;
  cursor: pointer;
}

.styles_ProfileMenuBottom__I-3a9 > div > span,
.styles_ProfileMenuBottom__I-3a9 > a > span {
  padding-right: 4px;
}

.styles_ProfileMenuBottom__I-3a9 > div:hover,
.styles_ProfileMenuBottom__I-3a9 > a:hover {
  background: #e8e8e8;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/HeaderMoreBox/styles.module.scss"],"names":[],"mappings":"AAGE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAFJ;;AAME;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAHJ;;AAKE;EACE,WAAA;EACA,YAAA;AAFJ;;AAIE;EACE,aAAA;AADJ;;AAGE;EACE,qBAAA;AAAJ;;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mCAAA;AACJ;;AAEE;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;AAAJ;;AAGE;EAIE,gCAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;;AAkBE;EAGE,mCAAA;EACA,kBAAA;EACA,kBAAA;AAjBJ;;AAiCE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AA9BJ;;AAiCE;;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AA9BJ;;AAiCE;;EAEE,kBAAA;AA9BJ;;AAiCE;;EAEE,mBAAA;AA9BJ","sourcesContent":["\n\n\n  .ProfileMenuMiddle {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 15px 0;\n    width: 100%;\n    // border-bottom: 1px solid #d2d2d2;\n  }\n  \n  .ProfileMenuMiddle p {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: #898989;\n  }\n  .checkMarkStyle{\n    width:20px;\n    height:20px;\n  }\n  .checkMarkStyle>input{\n    display: none;\n  }\n  .labelStyle{\n    padding: 0 !important;\n  }\n  .checkMarkStyle:after{\n    left: 7px !important;\n    top: 4px  !important;\n    width: 4px !important;\n    height: 8px !important;\n    border: solid white !important;\n    border-width: 0 3px 3px 0 !important;\n    transform: rotate(45deg) !important;\n\n  }\n  .ProfileMenuMiddle .color {\n    box-sizing: border-box;\n    width: 18px;\n    height: 18px;\n    border-radius: 50% ;\n    // margin: 8px 2px;\n    cursor: pointer;\n  }\n  \n  .unActive {\n    // border: 1px solid #dddddd;\n    // outline: 1px solid gray;\n    // outline-offset: 1px;\n    box-shadow: 0px 0px 0px 1px gray;\n    border-radius:50%;\n    position:relative;\n  }\n  // .unActive::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid gray;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .activeColor {\n    // outline: 2px solid #d8000d;\n    // outline-offset: 2px;\n    box-shadow: 0px 0px 0px 1px #d8000d;\n    border-radius:50%;\n    position:relative;\n  \n  }\n  // .activeColor::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid #d8000d;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .ProfileMenuBottom {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 8px 0;\n    width: 100%;\n    height: auto;\n  }\n  \n  .ProfileMenuBottom > div,\n  .ProfileMenuBottom a {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: rgba(0, 0, 0, 0.54);\n    border-radius: 4px;\n    padding: 6px 5px;\n    width: 100%;\n    cursor: pointer;\n  }\n  \n  .ProfileMenuBottom > div > span,\n  .ProfileMenuBottom > a > span {\n    padding-right: 4px;\n  }\n  \n  .ProfileMenuBottom > div:hover,\n  .ProfileMenuBottom > a:hover {\n    background: #e8e8e8;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProfileMenuMiddle": `styles_ProfileMenuMiddle__Z337a`,
	"checkMarkStyle": `styles_checkMarkStyle__dEf37`,
	"labelStyle": `styles_labelStyle__q2Cbl`,
	"color": `styles_color__bShzK`,
	"unActive": `styles_unActive__LAyLZ`,
	"activeColor": `styles_activeColor__nD5C8`,
	"ProfileMenuBottom": `styles_ProfileMenuBottom__I-3a9`
};
export default ___CSS_LOADER_EXPORT___;
